export default __webpack_public_path__ + "static/media/logo-branca.73071ab1.svg";